module.exports = __webpack_public_path__ + "img/chi.ce060df5.jpg";